/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Zonnepanelen() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Zonnepanelen</h1>
          <p>
            Sinds 25 juni 2013 hebben we 12 zonnepanelen op het dak liggen. 4 daarvan op het platte dak, 8 op het schuine dak. De panelen hebben een vermogen van 250 Wp, wat op een
            totaal van 3000 Wp uit komt. We kozen destijds voor het duurdere Enphase systeem, waarbij je niet 1 grote omvormer hebt voor alle panelen, maar ieder paneel zijn eigen
            omvormer heeft die onder het paneel zit. Het bespaart ruimte op zolder of in de garage, en het heeft een hoger rendement. Bovendien zouden we in ons geval sowieso 2
            omvormers moeten hebben, 1 voor het platte dak en 1 voor het schuine dak. Na wat rekenwerk was de conclusie dat dit systeem uiteindelijk goedkoper was, vanwege het
            hogere rendement.
          </p>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h2>De Opbrengst</h2>
          <p>
            In onderstaande tabel staan de opbrengsten per jaar van de zonnepanelen sinds het begin dat we ze hebben. De legenda bij deze tabel legt de betekenis van iedere kolom
            uit:
          </p>
          <div className="table-container">
            <table>
              <tbody>
                <tr>
                  <td className="left">Opbrengst (kWh)</td>
                  <td className="left">De opgewekte stroom door de zonnepanelen</td>
                </tr>
                <tr>
                  <td className="left">Volle zonuren</td>
                  <td className="left">
                    Volle zonuren in weerstation Deelen, zie <a href="http://www.zonurencalculator.nl/sun_hours_calculation">zonurencalculator.nl</a>
                  </td>
                </tr>
                <tr>
                  <td className="left">Opbrengst/zonuur</td>
                  <td className="left">
                    De opgewekte stroom gedeeld door het aantal zonuren, de opbrengst per zonuur dus. Dit is een maat voor de efficientie van de zonnepanelen, waarvan bekend is dat
                    die ieder jaar afneemt.
                  </td>
                </tr>
                <tr>
                  <td className="left">Opbrengst (€)</td>
                  <td className="left">
                    De totale opbrengst in euro's wat we door de opwek verdiend hebben dit jaar. Dat is de besparing op niet afgenomen stroom + geld dat we kregen voor
                    teruglevering aan het net
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Jaar</th>
                  <th>Opbrengst (kWh)</th>
                  <th>Volle zonuren</th>
                  <th>Opbrengst/zonuur</th>
                  <th>Opbrengst (€)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2013</td>
                  <td>1435,9 kWh **</td>
                  <td>500,57</td>
                  <td>2,8684 (100 %)</td>
                  <td>€ 309,10</td>
                </tr>
                <tr>
                  <td>2014</td>
                  <td>2841,3 kWh</td>
                  <td>1.001,51</td>
                  <td>2,8370 (98,91 %)</td>
                  <td>€ 636,02</td>
                </tr>
                <tr>
                  <td>2015</td>
                  <td>2957,4 kWh</td>
                  <td>1.049,63</td>
                  <td>2,8175 (98,23 %)</td>
                  <td>€ 662,15</td>
                </tr>
                <tr>
                  <td>2016</td>
                  <td>2849,7 kWh</td>
                  <td>1.021,22</td>
                  <td>2,7905 (97,29 %)</td>
                  <td>€ 350,38</td>
                </tr>
                <tr>
                  <td>2017</td>
                  <td>2668,5 kWh</td>
                  <td>984,36</td>
                  <td>2,7109 (94,51 %)</td>
                  <td>€ 465,95</td>
                </tr>
                <tr>
                  <td>2018</td>
                  <td>3081,7 kWh</td>
                  <td>1.146,11</td>
                  <td>2,6888 (93,74 %)</td>
                  <td>€ 569,61</td>
                </tr>
                <tr>
                  <td>2019</td>
                  <td>2806,9 kWh</td>
                  <td>1.084,00</td>
                  <td>2,5894 (90,27 %)</td>
                  <td>€ 521,24</td>
                </tr>
                <tr>
                  <td>2020</td>
                  <td>2843,3 kWh</td>
                  <td>1.088,78</td>
                  <td>2,6115 (91,04 %)</td>
                  <td>€ 487,94</td>
                </tr>
                <tr>
                  <td>2021</td>
                  <td>2583,5 kWh</td>
                  <td>1.027,95</td>
                  <td>2,5133 (87,62 %)</td>
                  <td>€ 572,25</td>
                </tr>
                <tr>
                  <td>2022</td>
                  <td>3086,8 kWh</td>
                  <td>1.180,53</td>
                  <td>2,6148 (91,16 %)</td>
                  <td>€ 1037,53</td>
                </tr>
                <tr>
                  <td>2023</td>
                  <td>2692,5 kWh</td>
                  <td>1.081,08</td>
                  <td>2,4906 (86,83 %)</td>
                  <td>€ 985,51</td>
                </tr>
                <tr>
                  <td>
                    <b>Totaal</b>
                  </td>
                  <td>
                    <b>29847,5 kWh</b>
                  </td>
                  <td>
                    <b>11644,22</b>
                  </td>
                  <td></td>
                  <td>
                    <b>€ 6597,68</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            In de laatste kolom is te zien wat we door de aanschaf van zonnepanelen ieder jaar nu toe bespaard hebben. Destijds kostten de zonnepanelen incl. montage €6950. Daarop
            kregen we een subsidie van de gemeenten Nijmegen van €1000 en konden we via de BTW teruggaaf nogmaals een bedrag van €969,34 terug krijgen. Tot dusver hebben we nog
            geen onderhoudskosten gehad aan de panelen. Netto hebben de zonnepanelen ons dus € 4980,60 gekost. Dat betekent dus dat we medio 2022 op break even zaten, en dat de
            zonnepanelen zich in 9 jaar terug verdiend hebben.
          </p>
          <p>
            Wat vooral ook interessant is, is de opbrengst van de afgelopen twee jaar. Die is veel hoger dan de jaren daarvoor, wat komt door de stijging van de stroomprijs. Omdat
            de salderingsregel nog even blijft bestaan rekenen energiemaatschappijen sinds 2024 een terugleververgoeding. In ons geval komt dat neer op ongeveer € 175 per jaar.
            Maar zelfs met die extra kosten blijft de besparing door zonnepanelen gewoon hoog. Er lijkt dus geen reden tot klagen te zijn.
          </p>
          <p>
            Wat verder opvalt is dat het rendement van de zonnepanelen sneller afneemt dan de informatie die je daar op internet over vindt. Daar wordt gesproken over een
            gemiddelde afname van 0,5% per jaar, met de kanttekening dat het grootste verlies in de eerste jaren zit. Na 25 jaar zou het rendement nog zo'n 80 % zijn. In 10 jaar is
            het rendement van onze panelen met 13,17 % afgenomen, dus gemiddeld 1,32 % per jaar. Of we de 80 % pas na 25 jaar halen durf ik te betwijfelen. Maar omdat de
            zonnepanelen zichzelf reeds terugverdiend hebben maakt dat allemaal niet zo veel meer uit...
          </p>
        </div>
      </div>
    </div>
  );
}

export default Zonnepanelen;
